import React, { useEffect } from 'react';
import { useNewUiTheme } from '../newUiTheme';
import { ViewStyle } from 'react-native';
import { useEventsPublisher } from 'event-bus';

export interface LoadingAnimationLayoutProps {
  isBig?: boolean,
  style?: ViewStyle,
}

export function LoadingAnimation(props: {
  isBig?: boolean,
  style?: ViewStyle,
}) {
  const uiTheme = useNewUiTheme();

  const eventsPublisher = useEventsPublisher();

  useEffect(() => {
    return () => {
      eventsPublisher.publish('POPUP_DATA_UPDATED', {});
    }
  }, []);

  return (
    <uiTheme.common.LoadingAnimationLayout isBig={props.isBig} style={props.style} />
  );
}
